/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chot_So_Approve_FailedInputs */

const vi_chot_so_approve_failed = /** @type {(inputs: Chot_So_Approve_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duyệt thất bại`)
};

/**

* @param {Chot_So_Approve_FailedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const chot_so_approve_failed = /** @type {((inputs?: Chot_So_Approve_FailedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chot_So_Approve_FailedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_chot_so_approve_failed(inputs)
});